import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { MdCheckCircle, MdOutlineError } from "react-icons/md";
import Button from "react-bootstrap/Button";
import "./result.css";
import ReceiptComponent from "./receipt/Receipt.jsx";

// Receipt Section Component - Now simplified since Receipt handles its own actions
const ReceiptSection = ({
  receiptData,
  fileName,
  theme,
  localizedText,
  autoDownload,
}) => (
  <div className="receipt-download-print-div">
    <ReceiptComponent
      data={receiptData}
      showActions={true}
      fileName={fileName}
      theme={theme}
      localizedText={localizedText}
      autoDownload={autoDownload}
      printData={{
        title: localizedText?.["transaction-details"] || "Transaction Details",
        text: localizedText?.["powered-by-blox"] || "Powered by Blox",
      }}
    />
  </div>
);

// Action Buttons Component
const ActionButtons = ({
  primaryButtonText,
  primaryButtonFunction,
  secondButton,
  secondaryButtonText,
  secondaryButtonFunction,
}) => (
  <div className="buttons-div">
    <Button
      className="primary-button inside-primary-button"
      onClick={primaryButtonFunction}
    >
      {primaryButtonText}
    </Button>
    {secondButton && (
      <Button
        className="secondary-button inside-secondary-button"
        onClick={secondaryButtonFunction}
      >
        {secondaryButtonText}
      </Button>
    )}
  </div>
);

// Main Result Component
const Result = (props) => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Default body content if no body prop is provided
  const defaultBody = (
    <>
      {props.receipt?.data && (
        <ReceiptSection
          receiptData={props.receipt.data}
          fileName={props.receipt.fileName}
          theme={props.theme}
          localizedText={props.localizedText}
          autoDownload={props.autoDownload}
        />
      )}

      <ActionButtons
        primaryButtonText={props.primaryButtonText}
        primaryButtonFunction={props.primaryButtonFunction}
        secondButton={props.secondButton}
        secondaryButtonText={props.secondaryButtonText}
        secondaryButtonFunction={props.secondaryButtonFunction}
      />
    </>
  );

  return (
    <>
      <div className="result-component-container content-container-no-hover">
        <div className="result-title">
          {props.success ? (
            <MdCheckCircle className="icon success-color-inside" />
          ) : (
            <MdOutlineError className="icon danger-color-inside" />
          )}
          {props.title}
        </div>
        <div className="description">{props.message}</div>

        {/* Render custom body or default body */}
        {props.body || defaultBody}
      </div>
    </>
  );
};

export default Result;
